import React from 'react';
import PropTypes from 'prop-types';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, isInvalid } from 'redux-form';

class PropertygroupsEditForm extends React.Component {
    constructor(props) {
        super(props);

        const {
            initialize,
            localisation,
        } = props;

        initialize({
            localisation: localisation,
        });
    }

    render() {
        const {
            localisationFields,
            form,
            localisation,
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    fields={ localisationFields }
                                    form={ form }
                                    localisation={ localisation }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

PropertygroupsEditForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
    ],
};

PropertygroupsEditForm.propTypes = {
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisation: PropTypes.object,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(PropertygroupsEditForm);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/edit/PropertygroupsEditForm.js